export default "__VITE_ASSET__bb0b3396__"